var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import {} from "axios";
import { computed, ref } from "vue";
import { useToast } from "@/composables/toast";
import { errorMessageAsString } from "@/utils/simple-error";
export function initRefs() {
    const managePermissionsOptions = ref([]);
    const accessPermissionsOptions = ref([]);
    const managePermissions = ref([]);
    const accessPermissions = ref([]);
    const simplePermissions = computed(() => {
        // we have one manage permission and read access can be that or not that but nothing else
        const hasOneManagePermission = managePermissions.value.length == 1;
        const hasAtMostOneAccessPermissions = accessPermissions.value.length < 2;
        if (!hasOneManagePermission || !hasAtMostOneAccessPermissions) {
            return false;
        }
        const managePermissionValue = managePermissions.value[0];
        return accessPermissions.value.length == 0 || accessPermissions.value[0] == managePermissionValue;
    });
    const checked = computed(() => {
        return accessPermissions.value.length > 0;
    });
    return {
        managePermissionsOptions,
        accessPermissionsOptions,
        managePermissions,
        accessPermissions,
        simplePermissions,
        checked,
    };
}
export function permissionInputParts(inputs) {
    const manageInput = inputs[0];
    const accessInput = inputs[1];
    return { manageInput, accessInput };
}
export function updateRefs(inputs, managePermissionsOptions, accessPermissionsOptions, managePermissions, accessPermissions) {
    const { manageInput, accessInput } = permissionInputParts(inputs);
    managePermissionsOptions.value = manageInput.options.map((v) => {
        return { roleName: v[0], roleValue: v[1] };
    });
    accessPermissionsOptions.value = accessInput.options.map((v) => {
        return { roleName: v[0], roleValue: v[1] };
    });
    managePermissions.value = manageInput.value;
    accessPermissions.value = accessInput.value;
}
export function useCallbacks(init) {
    const toast = useToast();
    function onError(e) {
        return __awaiter(this, void 0, void 0, function* () {
            toast.error(errorMessageAsString(e));
        });
    }
    function onSuccess(data) {
        return __awaiter(this, void 0, void 0, function* () {
            toast.success(data.data.message);
            init();
        });
    }
    init();
    return { onSuccess, onError };
}
